// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referral-prompt-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2050;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  animation: referral-prompt-fade-in 0.2s ease;
}

@keyframes referral-prompt-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.referral-prompt-card {
  background: var(--color-bg-canvas-surface, #fff);
  border-radius: 6px;
  padding: 28px 32px 24px;
  width: 100%;
  max-width: 380px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  animation: referral-prompt-slide-up 0.25s ease;
}

@keyframes referral-prompt-slide-up {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

.referral-prompt-header {
  text-align: center;
  margin-bottom: 20px;
}

.referral-prompt-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary, #0b0c0f);
  margin: 0 0 6px;
}

.referral-prompt-header p {
  font-size: 14px;
  color: var(--color-text-secondary, rgba(11, 12, 15, 0.72));
  margin: 0;
}

.referral-prompt-form {
  display: flex;
  gap: 8px;
}

.referral-prompt-form input {
  flex: 1 1;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid var(--color-border-input, #cfd3d8);
  border-radius: 4px;
  background: var(--color-bg-input, #ededed);
  color: var(--color-text-primary, #0b0c0f);
  outline: none;
  font-family: inherit;
  letter-spacing: 0.5px;
}

.referral-prompt-form input:focus {
  border-color: var(--color-accent-base, #c07b42);
}

.referral-prompt-form button {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  background: var(--color-text-primary, #0b0c0f);
  color: var(--color-bg-canvas-surface, #fff);
  cursor: pointer;
  white-space: nowrap;
}

.referral-prompt-form button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.referral-prompt-message {
  margin-top: 12px;
  font-size: 13px;
  text-align: center;
  padding: 8px;
  border-radius: 4px;
}

.referral-prompt-message--success {
  color: #15803d;
  background: rgba(21, 128, 61, 0.08);
}

.referral-prompt-message--error {
  color: #b91c1c;
  background: rgba(185, 28, 28, 0.08);
}

.referral-prompt-skip {
  display: block;
  margin: 16px auto 0;
  background: none;
  border: none;
  color: var(--color-text-secondary, rgba(11, 12, 15, 0.5));
  font-size: 13px;
  cursor: pointer;
  padding: 4px 8px;
}

.referral-prompt-skip:hover {
  color: var(--color-text-primary, #0b0c0f);
}
`, "",{"version":3,"sources":["webpack://./src/components/ReferralCodePrompt.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0DAA0D;EAC1D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,oDAAoD;EACpD,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,aAAa;EACb,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yDAAyD;EACzD,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":[".referral-prompt-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 2050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.45);\n  animation: referral-prompt-fade-in 0.2s ease;\n}\n\n@keyframes referral-prompt-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.referral-prompt-card {\n  background: var(--color-bg-canvas-surface, #fff);\n  border-radius: 6px;\n  padding: 28px 32px 24px;\n  width: 100%;\n  max-width: 380px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n  animation: referral-prompt-slide-up 0.25s ease;\n}\n\n@keyframes referral-prompt-slide-up {\n  from { opacity: 0; transform: translateY(12px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.referral-prompt-header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.referral-prompt-header h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-primary, #0b0c0f);\n  margin: 0 0 6px;\n}\n\n.referral-prompt-header p {\n  font-size: 14px;\n  color: var(--color-text-secondary, rgba(11, 12, 15, 0.72));\n  margin: 0;\n}\n\n.referral-prompt-form {\n  display: flex;\n  gap: 8px;\n}\n\n.referral-prompt-form input {\n  flex: 1;\n  padding: 10px 12px;\n  font-size: 14px;\n  border: 1px solid var(--color-border-input, #cfd3d8);\n  border-radius: 4px;\n  background: var(--color-bg-input, #ededed);\n  color: var(--color-text-primary, #0b0c0f);\n  outline: none;\n  font-family: inherit;\n  letter-spacing: 0.5px;\n}\n\n.referral-prompt-form input:focus {\n  border-color: var(--color-accent-base, #c07b42);\n}\n\n.referral-prompt-form button {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  border-radius: 4px;\n  background: var(--color-text-primary, #0b0c0f);\n  color: var(--color-bg-canvas-surface, #fff);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.referral-prompt-form button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.referral-prompt-message {\n  margin-top: 12px;\n  font-size: 13px;\n  text-align: center;\n  padding: 8px;\n  border-radius: 4px;\n}\n\n.referral-prompt-message--success {\n  color: #15803d;\n  background: rgba(21, 128, 61, 0.08);\n}\n\n.referral-prompt-message--error {\n  color: #b91c1c;\n  background: rgba(185, 28, 28, 0.08);\n}\n\n.referral-prompt-skip {\n  display: block;\n  margin: 16px auto 0;\n  background: none;\n  border: none;\n  color: var(--color-text-secondary, rgba(11, 12, 15, 0.5));\n  font-size: 13px;\n  cursor: pointer;\n  padding: 4px 8px;\n}\n\n.referral-prompt-skip:hover {\n  color: var(--color-text-primary, #0b0c0f);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
